import { useState, useEffect } from 'react'
import { getSalesFunnelForEdit } from '@user/store/salesFunnel/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetSalesFunnel = (id?: string) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    if (id) {
      const execute = async () => {
        try {
          setStatus('pending')
          const result = await dispatch(getSalesFunnelForEdit(id))

          if (mounted) {
            if (getSalesFunnelForEdit.fulfilled.match(result)) {
              setStatus('success')
            } else {
              setStatus('fail')
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
          }
        }
      }
      execute()
    }

    return () => {
      mounted = false
    }
  }, [dispatch, id])

  return status
}
